export enum UnitPCVStatus {
  CREATED = 'created',
  DISABLED = 'disabled',
  TAKEN = 'taken', //pago de reserva
  AVAILABLE = 'available',
  ASSIGNED = 'assigned', // para mandato de pago
  ON_DEED = 'on_deed', //escriturada
  SOLD_EXTERNAL = 'sold_external',
  TRANSFERRED = 'transferred', //cuando ya se firma la nueva promesa. --> la unidad de nosotros
}
